import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

export const fetchUpload = createAsyncThunk(
  "upload",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

export const fetchConvertImageArtData = createAsyncThunk(
  "convertImageArtData",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/convertImageArtData`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

export const saveimageartData = createAsyncThunk(
  "saveimageart",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/saveimageart`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

export const fetchStorePrintArtdata = createAsyncThunk(
  "storeprintartdata",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/storeprintartdata`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

interface ImageState {
  saveImageArtloading: boolean;
  uploadLoading: boolean;
  convertImageArtLoading: boolean;
  storePrintArtloading: boolean;
  saveImageArtData: any;
  uploadData: any;
  saveImageArtError: string;
  uploadError: string;
  storePrintArtError: any;
  convertImageArtLoadingError: string;
}

const initialState: ImageState = {
  saveImageArtloading: false,
  uploadLoading: false,
  storePrintArtloading: false,
  convertImageArtLoading: false,
  saveImageArtData: null,
  uploadData: null,
  saveImageArtError: "",
  uploadError: "",
  storePrintArtError: "",
  convertImageArtLoadingError: "",
};

export const imageSlice = createSlice({
  name: "image",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveimageartData.pending, (state) => {
        state.saveImageArtloading = true;
        state.saveImageArtError = "";
      })
      .addCase(saveimageartData.fulfilled, (state) => {
        state.saveImageArtloading = false;
      })
      .addCase(saveimageartData.rejected, (state, action) => {
        state.saveImageArtloading = false;
        state.saveImageArtError =
          action.error.message || "Failed to fetch art data";
      });
    builder
      .addCase(fetchUpload.pending, (state) => {
        state.uploadLoading = true;
        state.saveImageArtError = "";
        state.uploadData = null;
      })
      .addCase(fetchUpload.fulfilled, (state, action) => {
        state.uploadLoading = false;
        state.uploadData = action.payload;
      })
      .addCase(fetchUpload.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.error.message || "Something went wrong";
      });
    builder
      .addCase(fetchStorePrintArtdata.pending, (state) => {
        state.storePrintArtloading = true;
        state.storePrintArtError = "";
      })
      .addCase(fetchStorePrintArtdata.fulfilled, (state) => {
        state.storePrintArtloading = false;
      })
      .addCase(fetchStorePrintArtdata.rejected, (state, action) => {
        state.storePrintArtloading = false;
        state.storePrintArtError =
          action.error.message || "Something went wrong";
      });
    builder
      .addCase(fetchConvertImageArtData.pending, (state) => {
        state.convertImageArtLoading = true;
        state.storePrintArtError = "";
      })
      .addCase(fetchConvertImageArtData.fulfilled, (state) => {
        state.convertImageArtLoading = false;
      })
      .addCase(fetchConvertImageArtData.rejected, (state, action) => {
        state.convertImageArtLoading = false;
        state.convertImageArtLoadingError =
          action.error.message || "Something went wrong";
      });
  },
});
export default imageSlice.reducer;
